<a href="#" *ngIf="value!=='0'" (click)="onClick()">{{value}}</a>
<span *ngIf="value=='0'">{{value}}</span>
